import React, { useEffect, useState } from "react";
import "./bottomBar.scss";

import { Stack } from "react-bootstrap";
import { listMenu } from "./data/listMenu";
import { setGlobalState, useGlobalState } from "../../utils/state";
import { useNavigate } from "react-router-dom";
import NotificationBadge from "../notificationBadge/NotificationBadge";

const BottomBar = () => {
  const navigate = useNavigate();
  const [selectedIdBottomBar] = useGlobalState("selectedIdBottomBar");
  const [admin] = useGlobalState("admin");
  const [numberNotifications] = useGlobalState("numberNotifications");

  return (
    <div className="bottom-bar-container">
      <div className="bottom-bar-wrapper">
        <Stack gap={3} direction="horizontal">
          {listMenu ? (
            <>
              {listMenu.map((item) => {
                if (item.id === 2 && !admin) {
                  return null;
                } else {
                  return (
                    <Stack
                      direction="vertical"
                      gap={0.5}
                      key={item.id}
                      className="box-item-bottom-bar"
                      style={
                        item.id === 2
                          ? { borderLeft: "solid 1px #CDCDCD" }
                          : null
                      }
                      onClick={() => {
                        setGlobalState("selectedIdBottomBar", item.id);
                        navigate(".." + item.path);
                      }}
                    >
                      <div
                        className="div-icon-bottom-bar"
                        style={
                          selectedIdBottomBar === item.id
                            ? {
                                color: "#03626e",
                                fontWeight: "bold",
                              }
                            : null
                        }
                      >
                        {item.icon}
                        {item.id === 5 ? (
                          <NotificationBadge
                            top={-10}
                            right={-9}
                            width={18}
                            height={18}
                            numberNotifications={numberNotifications}
                          />
                        ) : null}
                      </div>
                      <span
                        className="name-page"
                        style={
                          selectedIdBottomBar === item.id
                            ? { fontWeight: 600, color: "#03626e" }
                            : null
                        }
                      >
                        {item.name}
                      </span>
                      {selectedIdBottomBar === item.id ? (
                        <div className="circular-selected"></div>
                      ) : null}
                    </Stack>
                  );
                }
              })}
            </>
          ) : null}
        </Stack>
      </div>
    </div>
  );
};

export default BottomBar;
